import { render } from "./Anticonceptivo_AtenObst.vue?vue&type=template&id=058a2ad7"
import script from "./Anticonceptivo_AtenObst.vue?vue&type=script&lang=js"
export * from "./Anticonceptivo_AtenObst.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__